import React, { createContext, useEffect, useState } from 'react';
import componentServices from 'Scripts/componentServices';
import { IOperationsItem } from 'Scripts/services/operationsHelper';
import * as jobActions from 'Scripts/jobActions';

interface IOperationsContextState {
    isFetchingItems: boolean;
    operationsItems: IOperationsItem[]
}

export const OperationsContext = createContext<IOperationsContextState>({ isFetchingItems: false, operationsItems: []});

export default ({ children }: { children?: React.ReactNode}) => {
	const [isFetchingItems, setFetching] = useState(false);
	const operationsItems = componentServices.operationsHelper.getOperationsItems();

	useEffect(() => {
		setFetching(true);
        
		const doFetch = async () => {
			await jobActions.fetchActiveJobs({ moduleKey: 'operations'});
			setFetching(false);
		}

		doFetch();
	}, []);

	return <OperationsContext.Provider value={ { isFetchingItems, operationsItems }}>{ children }</OperationsContext.Provider>
};